import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class StartDate extends Field {
  static attributesForModel() {
    return ['startDate'];
  }

  get title() {
    return 'Start date';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().subtract(3, 'months')),
      icon: { name: 'fa-regular fa-hourglass-start' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.startDate) {
      return {
        text: dateFormattedWithUserLocale(record.startDate),
        icon: { name: 'fa-regular fa-hourglass-start' },
      };
    }

    return {};
  }
}
